let measureContext: CanvasRenderingContext2D | null | undefined;

const getMeasureContext = () => {
  if (measureContext !== undefined) return measureContext;
  try {
    measureContext = document.createElement("canvas").getContext("2d");
    if (measureContext) {
      const family = getComputedStyle(document.body).fontFamily;
      measureContext.font = `500 11.5px ${family || "sans-serif"}`;
    }
  } catch {
    measureContext = null;
  }
  return measureContext;
};

export const textWidth = (text: string) => {
  const context = getMeasureContext();
  return context
    ? Math.ceil(context.measureText(text).width * 1.04)
    : text.length * 6.6;
};
